import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthenticatorOptionComponent } from './authenticator-option.component';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    AuthenticatorOptionComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class AuthenticatorOptionModule { }
